import { UomCategoryCreatePage } from '@/features/uom-category/pages/UomCategoryCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/uom-category/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["uom_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UomCategoryCreatePage,
})
